import { Component, OnInit,  Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchDropLocation } from '../../shared/models/DispatchDropLocation';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cp-status-panel',
    templateUrl: './status-panel.component.html',
    styleUrls: ['./status-panel.component.scss']
})
export class StatusPanelComponent implements OnInit {

    subscriptions: Subscription[] = [];

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) {
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.initData();
            }));
    }

    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any;
    boardStatusesData: any;
    searchParam: DispatchBoardSearch;
    filterSettings: DropDownFilterSettings;

    panelType: DispatchBoardPanels = DispatchBoardPanels.status;

    @Input() selectedView: string;
    @Input() viewName: any;
    @Output() openDetailRequest = new EventEmitter<object>();
    @Output() openRequest = new EventEmitter<object>();
    popupLock: boolean = false;
    loadingIndicator: boolean = true;
    quickFilter: string;
    quickFilterError: boolean = false;

    mouseDown: boolean = false;

    ngOnChanges() {
        this.initData();
    }
    ngOnInit() {
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.filterSettings = this.svc_data.filterSettings;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    initData() {
        if (this.selectedView) {
            //this.loadingIndicator = true;
            //this.boardStatusesData = null;
            //this.data = null;
            this.svc_data.GetDispatchBoardViewStatuses(this.selectedView).subscribe(data => {
                this.boardStatusesData = data;
                this.svc_data.boardStatusesData = this.boardStatusesData;

                if (data.error) {
                    alert('got an error back!');
                }
                this.searchParam.boardStatuses = [];
                for (var i = 0; i < this.boardStatusesData.length; i++) {
                    this.searchParam.boardStatuses.push(this.boardStatusesData[i].dispatchStatusId);
                }
            });
            // MM: move this call outside above results call as dont need the statuses to get the info now
            this.svc_data.GetOpenDispatches(this.searchParam).subscribe(data => {
                this.data = data;
                this.svc_data.statusList = data;
                this.loadingIndicator = false;
                if (data.error) {
                    alert('got an error back!');
                }
            });
            // MM: dont call here, just for test call
            //this.svc_data.GetDispatchBoardViewFilters('BA4FBC22-1CEA-41C0-9E51-4A351A346350').subscribe(data => {
            //});
        }
    }

    openDetail(details) {
        this.openDetailRequest.emit({ lock: !this.popupLock, detail: details });
    }

    setPopupLock(e) {
        this.popupLock = e;
    }

    filterChange(e) {
        //is value in list?
        if (this.data.find(obj => obj.description == e)) {
            this.quickFilterError = false;
        } else {
            this.quickFilterError = true;
        }
        this.quickFilter = e;
    }

    mouseUp(status: DispatchDropLocation) {
        if (!this.mouseDown) {
            this.svc_data.dispatchDropped(status);
        }
        this.mouseDown = false;
    }

    mouseOver(status: DispatchDropLocation) {
        this.svc_data.mouseHovering(status);
    }
}
